import type {
  SensorySignature,
  SensorySignatureInput,
  SignatureScope
} from '@/types';
import {
  normalizeSignature
} from '@/utils/storyElementsHelpers';
import { BaseService } from './baseService';

export interface SensorySignatureValidationResult {
  valid: boolean;
  errors: string[];
}

const defaultScope: SignatureScope = 'global';

class SensorySignatureService extends BaseService<SensorySignature> {
  create(input: SensorySignatureInput): SensorySignature {
    const now = this.now();

    return normalizeSignature({
      id: this.createId('signature'),
      storyElementsId: input.storyElementsId,
      name: input.name,
      description: input.description,
      scope: input.scope ?? defaultScope,
      scopeId: input.scopeId,
      scopeName: input.scopeName,
      trigger: input.trigger,
      frequency: input.frequency,
      uiState: { isExpanded: false },
      createdAt: now,
      updatedAt: now,
      notes: input.notes ?? ''
    });
  }

  validate(input: Partial<SensorySignatureInput>): SensorySignatureValidationResult {
    const errors: string[] = [];

    if (!input.name || input.name.trim().length === 0) {
      errors.push('Name is required.');
    }

    if (!input.description || input.description.trim().length < 20) {
      errors.push('Description must be at least 20 characters.');
    }

    if (!input.trigger || input.trigger.trim().length === 0) {
      errors.push('Trigger description is required.');
    }

    if (input.scope && input.scope !== 'global' && !input.scopeId) {
      errors.push('Scoped signatures require a scope target.');
    }

    return {
      valid: errors.length === 0,
      errors
    };
  }
}

export const sensorySignatureService = new SensorySignatureService();
